var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationClicked({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M43.859 40.484l-3.435-5.724a17.012 17.012 0 01-2.42-8.747v-5.016a13.998 13.998 0 00-27.997 0v5.014c0 3.08-.837 6.104-2.421 8.747l-3.444 5.726A1 1 0 005 41.997h37.993a1 1 0 00.866-1.513zm-37.085-.487l2.517-4.218A18.994 18.994 0 0012 26.004v-5.007a11.999 11.999 0 0123.997 0v5.014c0 3.443.935 6.822 2.706 9.775l2.527 4.209-34.455.002z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.995 0a4 4 0 00-3.999 4v3.999a1 1 0 102 0v-4a2 2 0 114 0v4a1 1 0 001.999 0v-4a4 4 0 00-4-3.999zM28.322 40.54a.997.997 0 00-.611-.5 1.01 1.01 0 00-1.088.365.99.99 0 00-.028 1.14 2.96 2.96 0 010 2.978 2.99 2.99 0 01-1.097 1.09 3.017 3.017 0 01-3 0 2.99 2.99 0 01-1.098-1.09 2.961 2.961 0 010-2.978.99.99 0 00-.328-1.409 1.009 1.009 0 00-1.398.405 4.937 4.937 0 00-.01 4.97 4.983 4.983 0 001.831 1.822 5.03 5.03 0 005.008 0 4.983 4.983 0 001.83-1.821 4.938 4.938 0 00-.009-4.971h-.002z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationClicked);
export default __webpack_public_path__ + "static/media/notification_clicked.0f3df3454be09ac8f8f428fa341a71d1.svg";
export { ForwardRef as ReactComponent };